/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Health_And_Safety_DisruptionInputs */



/**
* | output |
* | --- |
* | "Health and Safety Disruption" |
*
* @param {Sanction_Sub_Health_And_Safety_DisruptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_health_and_safety_disruption = /** @type {((inputs?: Sanction_Sub_Health_And_Safety_DisruptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Health_And_Safety_DisruptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Perturbation de Santé et Sécurité")
	if (locale === "es") return /** @type {LocalizedString} */ ("Perturbación de Salud y Seguridad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Perturbação de Saúde e Segurança")
	if (locale === "it") return /** @type {LocalizedString} */ ("Violazione di Salute e Sicurezza")
	return /** @type {LocalizedString} */ ("Health and Safety Disruption")
});